import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import useCart from '../../data/hooks/cart_hook';
import { RootState } from '../../data/reducers';
import { AppDispatch } from '../../data/storeConfig';
import { CartProductTile } from '../../shared/components/product_components/cart_product_tile';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import { formatAmount, getImageUrl } from '../../utility/common';
import * as storeActions from '../../data/reducers/store.reducer';
import { PurchaseOrder } from '../../data/models/purchase_order_response';
import { PurchaseOrderTile } from '../../shared/components/order_components/purchase_order_tile';

export const PastOrdersPage = () => {
  const { storeSlug, orderId } = useParams<any>();
  const dispatch = useDispatch<AppDispatch>();
  const { shopperAccountId } = useSelector((state: RootState) => state.authReducer);
  const { purchaseOrders } = useSelector((state: RootState) => state.storeReducer);

  useEffect(() => {
    if (storeSlug && shopperAccountId) {
      dispatch(
        storeActions.fetchPurchaseOrders({
          storeSlug: storeSlug,
          shopperAccountId: shopperAccountId,
        }),
      );
    }
  }, [storeSlug, shopperAccountId]);

  return (
    <NavigationShell title={`Orders`} isBackVisible={false}>
      <div className="">
        <ul>
            {purchaseOrders?.map((po: PurchaseOrder) => <PurchaseOrderTile purchaseOrder={po} key={po.purchaseOrderId} />)}
        </ul>
      </div>
    </NavigationShell>
  );
};
